import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { withStyles } from '@material-ui/core/styles';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Switch from '@material-ui/core/Switch';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

import SelectWrapped from './MultiselectComponent';
import RangeComponent from './RangeComponent';

import { postData } from './lib/common';

const FILTER_TYPES = Object.freeze({
    'SELECT': 'SELECT',
    'MULTISELECT': 'MULTISELECT',
    'MULTISELECT-MANY': 'MULTISELECT-MANY',
    'DATE-RANGE': 'DATE-RANGE',
    'BOOLEAN-SWITCH': 'BOOLEAN_SWITCH',
    'BOOLEAN-SWITCH-NOTNULL': 'BOOLEAN_SWITCH-NOTNULL',
    'BOOLEAN-SELECT': 'BOOLEAN-SELECT',
})


class RenderSpecialFilters extends Component {
    render() {
        const {parentState, handleMultiselectChange, classes} = this.props;

        if (
            !parentState.filtersState.building_type || 
            !Object.keys(parentState.FIELDS_SCHEMA).includes(parentState.filtersState.building_type)
        ) {
            return null
        }

        const fieldsSchema = parentState.FIELDS_SCHEMA[parentState.filtersState.building_type];
        let filters = [];

        Object.keys(fieldsSchema.fields).map((fieldName) => {
            const singleField = fieldsSchema.fields[fieldName];

            if (!('filter' in singleField)) {
                return null
            }
            
            const filterType = singleField['filter'].type.toUpperCase();
            
            if (!(filterType in FILTER_TYPES)) {
                console.log('Unknown filter type: ' + filterType);
                return null
            }

            if ( filterType == 'SELECT' || filterType == 'MULTISELECT' || filterType == 'BOOLEAN-SELECT') {
                console.log('Rendering '+ filterType + ' for ' + fieldName);
                filters.push(
                    <FormControl 
                        ref={
                            'filter-by-'+'filter__' + parentState.filtersState.building_type + '__' + fieldName
                        } 
                        component="fieldset"
                    >
                        <FormLabel component="legend">{singleField.label}</FormLabel>
                        <Input
                          fullWidth
                          inputComponent={SelectWrapped}
                          value={parentState.filtersState['filter__' + parentState.filtersState.building_type + '__' + fieldName]}
                          onChange={handleMultiselectChange('filter__' + parentState.filtersState.building_type + '__' + fieldName)}
                          placeholder="Начните набирать"
                          name="react-select-chip"
                          inputProps={{
                            classes,
                            multi: filterType == 'MULTISELECT',
                            instanceId: 'react-select-chip',
                            id: 'react-select-chip',
                            simpleValue: true,
                            options: Object.keys(singleField['filter'].options).map(
                                t => ({
                                  value: t,
                                  label: singleField['filter'].options[t],
                                })
                            ),
                          }}
                        />
                    </FormControl>
                )
        }    
        });
        return filters
    }
}

class FilterComponent extends Component {
    filterContainerStyles = {
        transition: 'width 500ms',
        flexDirection: 'column',
        margin: '0.5em',
        overflowY: 'visible',
    }

    paperStyles = {
        flexDirection: 'column',
        margin: '0.1em',
        marginBottom: '0.5em',
        padding: '1em',
        overflowY: 'visible',
    }

    state = {
        CITIES: [],
    }

    handleSwitchChange = (name) => async (event) => {
        this.setState({lastChangedFilter: name})
        await this.updateFilters({ [name]: event.target.checked })
    };

    handleMultiselectChange = (name) => async (value) => {
        this.setState({lastChangedFilter: name})
        await this.updateFilters({
          [name]: (value == [''] || value === null) ? null : value.split(','),
        });
    };

    handleSelectChange = (name) => async (value) => {
        this.setState({lastChangedFilter: name})
        await this.updateFilters({
          [name]: (value == [''] || value === null) ? null : value.split(',')[0],
        });
    };

    handleRangeChange = (name) => async ([min, max]) => {
        this.setState({lastChangedFilter: name})
        await this.updateFilters({
            [name]: [new Date(min, 0 , 1), new Date(max, 0, 1)]
        });
    };

    async componentDidMount() {
        const { waitingForResponse } = this.props
        waitingForResponse(true)
        let resp = await fetch('/api/metadata?cities&fields_schema', {credentials: 'include'})
        let data = await resp.json()
        
        let initialDefaultFilters = Object.keys(
            data['fields_schema'].default.fields
        ).filter(
            f => 'filter' in data['fields_schema'].default.fields[f]
        );
        
        let initialSpecialFilters = Object.keys(
            data['fields_schema']
        ).filter(
            building => building != 'default'
        ).map(
            building => Object.keys(
                data['fields_schema'][building].fields
            ).filter(
                field => 'filter' in data['fields_schema'][building].fields[field]
            ).map(
                field => 'filter__' + building + '__' + field
            )
        ).reduce(
            (acc, curr) => [...acc, ...curr], []
        );

        this.setState({
            CITIES: data['cities'],
            FIELDS_SCHEMA: data['fields_schema'],
            filtersState: Object.assign(
                {},
                ...[...initialDefaultFilters, ...initialSpecialFilters].map(
                    f => {let x = {}; x[f] = undefined; return x;}
                )
            )
        })

        this.baseFiltersState = Object.assign({}, this.state.filtersState)
        waitingForResponse(false)
    }

    componentDidUpdate() {
        const {isWaitingForResponse} = this.props;
        if (
            this.state.lastChangedFilter 
            && !isWaitingForResponse
            && ('filter-by-' + this.state.lastChangedFilter) in this.refs
        ) {
            ReactDOM.findDOMNode(this.refs['filter-by-' + this.state.lastChangedFilter]).scrollIntoView();
            this.setState({lastChangedFilter: null});
        }
    }

    async resetFiltersState() {
        await this.updateFilters(this.baseFiltersState);
    }

    eqFilterCondition(field, state_field) {
        // good for bool and select and any single value equivalence
        return state_field ? {
            'field': field,
            'op': '=',
            'args': [state_field]
        } : null;
    }

    notNullFilterCondition(field) {
        return {
            'field': field,
            'op': '!=',
            'args': ["null"]
        };
    }
    notFalseFilterCondition(field) {
        return {
            'field': field,
            'op': '!=',
            'args': ["false"]
        }
    }

    multiselectFilterCondition(field, state_field_array) {
        return state_field_array ? {
            'field': field,
            'op': 'in',
            'args': state_field_array
        } : null;
    }

    containsCondition(field, state_field_array) {
        return state_field_array ? {
            'field': field,
            'op': 'contains',
            'args': state_field_array
        } : null;
    }

    betweenCondition(field, [min, max]) {
        return {
            'field': field,
            'op': 'between',
            'args': [min, max]
        }
    }

    async updateFilters(newValues) {
        
        const { onFilterResults, waitingForResponse } = this.props
        
        waitingForResponse(true)
        
        let
            request = {},
            conditions = [],
            tmpState = {...this.state.filtersState, ...newValues};

        let me = this
        Object.keys(tmpState).map((key) => {
            if (tmpState[key] !== undefined && tmpState[key] !== null) {
                if (key.startsWith('filter__')) {
                    console.log('processing special filter ' + key)
                    const
                        [_, currentBuildingType, currentField] = key.split('__'),
                        schema = me.state.FIELDS_SCHEMA[currentBuildingType].fields[currentField],
                        filterType = schema.filter.type.toUpperCase();
                    if (filterType == 'SELECT') {
                        conditions.push(me.eqFilterCondition(['special_fields', currentField], tmpState[key]))
                    } else if (filterType == 'MULTISELECT') {
                        conditions.push(me.multiselectFilterCondition(['special_fields', currentField], [tmpState[key]]))
                    }
                } else {
                    const filterType = me.state.FIELDS_SCHEMA.default.fields[key].filter.type.toUpperCase();
                    console.log('processing regular filter ' + key + ' of type ' + filterType)
                    if (filterType == 'BOOLEAN-SWITCH-NOTNULL') {
                        conditions.push(me.notNullFilterCondition(key))
                    } else if (filterType == 'BOOLEAN-SWITCH') {
                        conditions.push(me.eqFilterCondition(key, tmpState[key]))
                    } else if (filterType == 'SELECT') {
                        conditions.push(me.eqFilterCondition(key, tmpState[key]))
                    } else if (filterType == 'MULTISELECT') {
                        conditions.push(me.multiselectFilterCondition(key, [tmpState[key]]))
                    } else if (filterType == 'MULTISELECT-MANY') {
                        conditions.push(me.containsCondition(key, [tmpState[key]]))
                    } else if (filterType == 'BOOLEAN-SELECT') {
                        conditions.push(me.eqFilterCondition(key, tmpState[key] == 'null' ? null : tmpState[key]))
                    } else if (filterType == 'DATE-RANGE') {
                        conditions.push(me.betweenCondition(key, tmpState[key]))
                    } else {
                        console.log('not supported filter type ' + filterType)
                    }
                }
            }
        });

        conditions = conditions.filter(e => e)

        if (tmpState.building_type) {
            request[tmpState.building_type] = conditions
        } 
        else
        {
            request['default'] = conditions
        }

        console.log('call to filter api')
        console.log(request)

        postData(
            '/api/filter',
            request
        ).then(
            data => {
                console.log('fetched ' + data.length + ' results from filter')
                onFilterResults(data)
                this.setState({filtersState: tmpState})
            }
        ).catch(
            error => console.log(error)
        ).finally(
            () => {
                waitingForResponse(false);
                this.setState({filtersState: tmpState});
            }
        )
        console.log('updateFilters!')
        console.log(this.state)
    }

    renderSelectFilter (classes, label, helper, fieldName, options=[], multi=false) {
        let handlerFunc = this.handleSelectChange(fieldName);
        if (multi) {
            handlerFunc = this.handleMultiselectChange(fieldName);
        }

        let realOptions = (
            options.length ? options :
            Object.keys(
                this.state.FIELDS_SCHEMA.default.fields[fieldName].filter.options
            ).map(
                t => ({
                   'value': t,
                   'label': this.state.FIELDS_SCHEMA.default.fields[fieldName].filter.options[t]
                })
            )
        );

        return (
            <FormControl ref={'filter-by-'+fieldName} style={{display: 'block'}} component="fieldset">
                {label ? <FormLabel component="legend">{label}</FormLabel> : null}
                {helper ? <FormHelperText>{helper}</FormHelperText> : null}
                <Input
                  fullWidth
                  inputComponent={SelectWrapped}
                  value={this.state.filtersState[fieldName]}
                  onChange={handlerFunc}
                  placeholder="Начните набирать"
                  name="react-select-chip"
                  inputProps={{
                    classes,
                    multi: multi,
                    instanceId: 'react-select-chip',
                    id: 'react-select-chip',
                    simpleValue: true,
                    options: realOptions,
                  }}
                />
            </FormControl>
        )
    }
    renderSwitchFilter(label, fieldName) {
        return (
            <FormControl ref={'filter-by-'+fieldName} component="fieldset">
                <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.filtersState[fieldName]}
                        onChange={this.handleSwitchChange(fieldName)}
                        value={fieldName}
                        color='primary'
                      />
                    }
                    label={label}
                />
            </FormControl>
        )
    }
    renderYearRangeFilter(label, fieldName, defaultValue=[1990, 2018]) {
        return (
            <RangeComponent
                ref={'filter-by-'+fieldName}
                value={
                    this.state.filtersState[fieldName] ?  
                    this.state.filtersState[fieldName].map(d => d.getFullYear())
                    : defaultValue
                }
                onAfterChange={this.handleRangeChange(fieldName)}
                label={label}
                step={1}
                max={defaultValue[1]}
                min={defaultValue[0]}
            />
        )
    }

    render () {
        const { showingFilters, classes, isWaitingForResponse, authorizedUser } = this.props
        if (isWaitingForResponse || !this.state.FIELDS_SCHEMA) {
            return null
        }
        return (
            <div id='filter-panel' style={{...this.filterContainerStyles, ...{display: showingFilters ? 'flex' : 'none'}}}>
                <Button onClick={() => this.resetFiltersState()}>Сбросить фильтры</Button>
                <Paper style={this.paperStyles}>
                    {this.renderSelectFilter(
                        classes,
                        'Населенный пункт',
                        '',
                        'city',
                        this.state.CITIES.map(
                            c => ({
                              value: c,
                              label: c,
                            })
                        )
                    )}
                    <br />
                    {this.renderSelectFilter(
                        classes,
                        'Тип спортивного объекта',
                        'назначение спортивного сооружения',
                        'building_type'
                    )}
                    <br />
                    <RenderSpecialFilters
                        parentState={this.state}
                        handleMultiselectChange={this.handleMultiselectChange}
                        classes={classes}
                    />
                    {this.renderSelectFilter(
                        classes,
                        'Специализация',
                        'секции, виды спорта',
                        'sections',
                        {multi: true}
                    )}
                    <br />
                    {this.renderSwitchFilter(
                        'Виртуальный тур',
                        'tour'
                    )}
                    <br />
                    {authorizedUser ?
                    this.renderSwitchFilter(
                        'Опубликован',
                        'is_public'
                    ) : null }
                </Paper>
                <Paper style={this.paperStyles}>
                    {this.renderSelectFilter(
                        classes,
                        'Уровень доступности',
                        '',
                        'accessibility'
                    )}
                    <br />
                    {this.renderSelectFilter(
                        classes,
                        'Категории доступности',
                        '',
                        'accessibility_categories',
                        {multi: true}
                    )}
                </Paper>
                {authorizedUser ?
                <Paper style={this.paperStyles}>
                    {this.renderSelectFilter(
                        classes,
                        'Регистрация во Всероссийском реестре спортивных сооружений',
                        '',
                        'is_registered'
                    )}
                    <br />
                    {this.renderYearRangeFilter(
                        'Год регистрации',
                        'registration_date'
                    )}
                    <br />
                    {this.renderSelectFilter(
                        classes,
                        'Категория регистрации',
                        '',
                        'registration_category'
                    )}
                    <br />
                    {this.renderSelectFilter(
                        classes,
                        'Заявка на регистрацию',
                        '',
                        'is_registration_applied'
                    )}
                    <br />
                    {this.renderSelectFilter(
                        classes,
                        'Медицинский кабинет',
                        '',
                        'has_medic'
                    )}
                </Paper> : null}
                {authorizedUser ?
                <Paper style={this.paperStyles}>
                    {this.renderSelectFilter(
                        classes,
                        'Форма собственности',
                        '',
                        'owner'
                    )}
                    <br />
                    {this.renderYearRangeFilter(
                        'Год постройки',
                        'construction_date'
                    )}
                    <br />
                    {this.renderSelectFilter(
                        classes,
                        'Реконструкция/ремонт',
                        'тип проведенных работ',
                        'reconstruction_type'
                    )}
                    <br />
                    {this.renderYearRangeFilter(
                        'Год ремонта/реконструкции',
                        'reconstruction_date'
                    )}
                </Paper> 
                : null}
            </div>
        )
    }
}

export default withStyles()(FilterComponent)


// WEBPACK FOOTER //
// ./src/FilterComponent.js